import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import { connect } from 'react-redux'
import { initialize } from 'redux-form'
import { bindActionCreators } from 'redux'

import { ContatoForm } from '../../components'
import * as contatoComercializadoraActionCreators from '../../redux/modules/contatoComercializadora'
import * as funcaoActionCreators from '../../redux/modules/funcao'
import * as flashMessageActionCreators from '../../redux/modules/flashMessage'

import { mapToDropdown } from '../../utils/parse'

class ContatoComercializadoraFormContainer extends Component {
  static propTypes = {
    id: PropTypes.string,
    initialize: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    comercializadora: PropTypes.object,

    fetchContatoComercializadora: PropTypes.func.isRequired,
    createContatoComercializadora: PropTypes.func.isRequired,
    updateContatoComercializadora: PropTypes.func.isRequired,

    funcaoDropdown: PropTypes.array.isRequired,
    fetchMultipleFuncao: PropTypes.func.isRequired,

    showSuccessfulFlashMessage: PropTypes.func.isRequired,
    showErrorFlashMessage: PropTypes.func.isRequired,
    shouldHideFlashMessage: PropTypes.bool.isRequired,
    hideFlashMessage: PropTypes.func.isRequired,

    error: PropTypes.object,
  }

  async componentDidMount () {
    await this.props.fetchMultipleFuncao()
    if (this.props.id) {
      const contato = await this.props.fetchContatoComercializadora(this.props.id)
      this.props.initialize('ContatoForm', { contato })
    }
  }

  handleUpdate = async (contatoComercializadora) => {
    const comercializadoraId = this.props.comercializadora.id

    if (await this.props.updateContatoComercializadora(this.props.id, contatoComercializadora)) {
      this.props.showSuccessfulFlashMessage('', 'update')
      this.props.history.push(`/comercializadoras/${comercializadoraId}/contatos`)
    } else {
      this.props.showErrorFlashMessage('', 'update', this.props.error)
    }
  }

  handleCreate = async (contatoComercializadora) => {
    const comercializadoraId = this.props.comercializadora.id

    if (await this.props.createContatoComercializadora(comercializadoraId, contatoComercializadora)) {
      this.props.showSuccessfulFlashMessage('', 'create')
      this.props.history.push(`/comercializadoras/${comercializadoraId}/contatos`)
    } else {
      this.props.showErrorFlashMessage('', 'create', this.props.error)
    }
  }

  handleSubmitResource = async (contatoComercializadora) => {
    if (this.props.id) {
      this.handleUpdate(contatoComercializadora)
    } else {
      this.handleCreate(contatoComercializadora)
    }
  }

  componentWillUnmount () {
    if (this.props.shouldHideFlashMessage)
      this.props.hideFlashMessage()
  }

  render () {
    return (
      <ContatoForm titleAs='h3' noPadded
        funcaoDropdown={this.props.funcaoDropdown}
        onSubmit={(contatoComercializadora) => this.handleSubmitResource(contatoComercializadora)} />
    )
  }
}

function mapStateToProps ({contatoComercializadora, funcao, status, flashMessage}, {match}) {
  const { id } = match.params

  const funcaoDropdown = mapToDropdown(
    funcao,
    e => e.get('id'),
    e => e.get('nome')
  )

  if (id) {
    return {
      id,
      contatoComercializadora: contatoComercializadora.get('id'),
      funcaoDropdown,
      error: status.getIn(['contatoComercializadora', 'error']),
      shouldHideFlashMessage: flashMessage.get('isError'),
    }
  }
  return {
    funcaoDropdown,
    error: status.getIn(['contatoComercializadora', 'error']),
    shouldHideFlashMessage: flashMessage.get('isError'),
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    ...contatoComercializadoraActionCreators,
    ...funcaoActionCreators,
    ...flashMessageActionCreators,
    ...{initialize},
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ContatoComercializadoraFormContainer))
